// src/pages/Programs.js
import React from 'react';

const Programs = () => {
    return (
        <div>
            <h1>Our Programs</h1>
            <p>Details about the programs we offer.</p>
        </div>
    );
};

export default Programs;
